import { ImageScaleView, ImageScaleViewOpts } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import i18n from 'src/lib/i18n/i18n';
import StateObserver from 'src/StateObserver';
import {
  canPlayLeague,
  getCurrentLeaguePhase,
} from 'src/replicant/match2/leagues/leagues.getters';
import { matchTheme } from 'src/game/theme/match2/Match2Theme';

type Match2LevelPanelOpts = Omit<
  ImageScaleViewOpts,
  'image' | 'width' | 'height'
>;

export class Match2LevelPanel extends ImageScaleView {
  private levelText: LangBitmapFontTextView;

  constructor(opts: Match2LevelPanelOpts = {}) {
    const width = 136;
    const height = 64;
    super({
      image: matchTheme().getUIAsset('panel_goal_level.png'),
      width,
      height,
      centerOnOrigin: true,
      ...opts,
    });

    this.levelText = new LangBitmapFontTextView({
      parent: this,
      font: 'Body',
      color: '#D3613F',
      size: 28,
      width: 90,
      height: 36,
      x: width * 0.5,
      y: height * 0.5 + 3,
      centerOnOrigin: true,
      localeText: () => i18n('match2.ui.lv', { level: 'X' }),
      verticalAlign: 'center',
      align: 'center',
    });
  }

  public setLevel(level: number) {
    const { user } = StateObserver.getState();

    if (canPlayLeague(user)) {
      this.levelText.localeText = () => `Ph. ${getCurrentLeaguePhase(user)}`;
      return;
    }

    this.levelText.localeText = () => i18n('match2.ui.lv', { level });
  }
}
